import React, { useState, useEffect } from "react";

import { Button, Spinner, Row, ButtonGroup } from "react-bootstrap";
import { Archive} from "react-bootstrap-icons";
import ItemsGrid  from "../ItemsGrid";

import { lastSuccessBackupItems, getArchivedBackupItems } from "../../_helpers/api";

const BackupItems = (props) => {

  const [ loading, setLoading ] = useState(true);
  const [ backupItems, setBackupItems ] = useState([]);

  const [ filterLastSuccess, setFilterLastSuccess ] = useState(0);  // number of days since last success
  const [ showArchived, setShowArchived ] = useState(false);
  
  useEffect(() => {
    setLoading(true);
    if (showArchived) {
      getArchivedBackupItems().then((data) => {
        setBackupItems(data);
        setLoading(false);
      });
    } else {
      lastSuccessBackupItems(filterLastSuccess).then((data) => {
        setBackupItems(data);
        setLoading(false);
      });
    }
  }, [filterLastSuccess, showArchived]);

  const filterLastSuccessChangeHandler = (days) => {
    setFilterLastSuccess(days);
    setShowArchived(false);
  }

  return (
    <>
      <Row className="m-3 justify-content-end">
        <ButtonGroup size="sm">
          <Button variant={filterLastSuccess === 0 ? "primary" : "outline-primary"} onClick={() => filterLastSuccessChangeHandler(0)}>Alle</Button>
          <Button variant={filterLastSuccess === 1 ? "primary" : "outline-primary"} onClick={() => filterLastSuccessChangeHandler(1)}>Letzter Erfolg {">"}1d</Button>
          <Button variant={filterLastSuccess === 3 ? "primary" : "outline-primary"} onClick={() => filterLastSuccessChangeHandler(3)}>Letzter Erfolg {">"}3d</Button>
          <Button variant={filterLastSuccess === 7 ? "primary" : "outline-primary"} onClick={() => filterLastSuccessChangeHandler(7)}>Letzter Erfolg {">"}7d</Button>
          <Button variant={filterLastSuccess === 14 ? "primary" : "outline-primary"} onClick={() => filterLastSuccessChangeHandler(14)}>Letzter Erfolg {">"}14d</Button>
          <Button variant={showArchived ? "primary" : "outline-primary"} onClick={() => {setShowArchived(!showArchived); setFilterLastSuccess(0);}}><Archive /></Button>
        </ButtonGroup>
      </Row>
      {loading ? <Spinner animation="border" /> : (
        <ItemsGrid backupItems={backupItems} filterLastSuccess={filterLastSuccess} showArchived={showArchived} />
      )}
    </>
  )
}

export default BackupItems;
